import { supabase } from "../client";
import { LeadRepository } from "../repositories/lead.repository";
import { ProfileRepository } from "../repositories/profile.repository";
import { LeadService } from "../services/lead.service";
import { AuthService } from "../services/auth.service";

/**
 * Dependency container — single composition root.
 * Components never import Supabase directly; they consume these services.
 */
const leadRepository = new LeadRepository(supabase);
const profileRepository = new ProfileRepository(supabase);

export const container = {
  leadRepository,
  profileRepository,
  leadService: new LeadService(leadRepository),
  authService: new AuthService(supabase),
} as const;

export type Container = typeof container;
